// @generated by web/tools/codegen — DO NOT EDIT
//
// Source: web/manifests/metrics.yaml
// Run:    node tools/codegen/main.mjs metrics

import { type MetricLabels, reportMetric } from './reporter';

/** Largest Contentful Paint — time to render the largest visible element. */
export interface WebLcpMsLabels extends MetricLabels {
  /** Route pattern (e.g. /listings/[slug]) */
  page: string;
}

export function reportWebLcpMs(value: number, labels: WebLcpMsLabels) {
  reportMetric('web_lcp_ms', value, labels);
}

/** First Input Delay — time from first interaction to browser response. */
export interface WebFidMsLabels extends MetricLabels {
  /** Route pattern */
  page: string;
}

export function reportWebFidMs(value: number, labels: WebFidMsLabels) {
  reportMetric('web_fid_ms', value, labels);
}

/** Cumulative Layout Shift — visual stability score. */
export interface WebClsLabels extends MetricLabels {
  /** Route pattern */
  page: string;
}

export function reportWebCls(value: number, labels: WebClsLabels) {
  reportMetric('web_cls', value, labels);
}

/** Interaction to Next Paint — responsiveness to user interactions. */
export interface WebInpMsLabels extends MetricLabels {
  /** Route pattern */
  page: string;
}

export function reportWebInpMs(value: number, labels: WebInpMsLabels) {
  reportMetric('web_inp_ms', value, labels);
}

/** Time to First Byte — initial server response time. */
export interface WebTtfbMsLabels extends MetricLabels {
  /** Route pattern */
  page: string;
}

export function reportWebTtfbMs(value: number, labels: WebTtfbMsLabels) {
  reportMetric('web_ttfb_ms', value, labels);
}

/** Client-measured Connect-RPC round-trip time. */
export interface WebRpcDurationMsLabels extends MetricLabels {
  /** RPC method name */
  method: string;
  /** Rolled-up outcome bucket (ok/error/timeout) */
  status: 'UNSPECIFIED' | 'OK' | 'ERROR' | 'TIMEOUT';
}

export function reportWebRpcDurationMs(value: number, labels: WebRpcDurationMsLabels) {
  reportMetric('web_rpc_duration_ms', value, labels);
}

/** Client-side route transition duration. */
export interface WebRouteChangeMsLabels extends MetricLabels {
  /** Previous route pattern */
  from: string;
  /** Target route pattern */
  to: string;
}

export function reportWebRouteChangeMs(value: number, labels: WebRouteChangeMsLabels) {
  reportMetric('web_route_change_ms', value, labels);
}

/** Time from initial HTML to full React hydration. */
export interface WebHydrationMsLabels extends MetricLabels {
  /** Route pattern */
  page: string;
}

export function reportWebHydrationMs(value: number, labels: WebHydrationMsLabels) {
  reportMetric('web_hydration_ms', value, labels);
}
